import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "event-swiper__title" };
var _hoisted_2 = { class: "event-swiper__date" };
var _hoisted_3 = { class: "date-part" };
var _hoisted_4 = { class: "time-part" };
import { Swiper, SwiperSlide } from 'swiper/vue';
import { formatEventDate } from '@/utils/format-date';
import ClockIcon from '@/icons/ClockIcon.vue';
import { Pagination } from 'swiper/modules';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EventSwiper',
    props: {
        events: {
            type: Object,
            required: true
        }
    },
    setup: function (__props) {
        var renderPaginationBullet = function (index, className) {
            return "<span class=\"".concat(className, " event-swiper__pagination-bullet\"></span>");
        };
        var onSlideChange = function (swiper) {
            var bullets = document.querySelectorAll('.event-swiper__pagination-bullet');
            var slidesPerView = swiper.params.slidesPerView;
            var activeIndex = swiper.activeIndex;
            bullets.forEach(function (bullet, index) {
                if (index >= activeIndex && index < activeIndex + slidesPerView) {
                    bullet.classList.add('active');
                }
                else {
                    bullet.classList.remove('active');
                }
            });
        };
        return function (_ctx, _cache) {
            var _component_el_icon = _resolveComponent("el-icon");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Swiper), {
                    class: "event-swiper",
                    "slides-per-view": 1,
                    pagination: {
                        el: '.event-swiper__pagination',
                        clickable: true,
                        renderBullet: renderPaginationBullet
                    },
                    modules: [_unref(Pagination)],
                    onSlideChange: onSlideChange
                }, {
                    default: _withCtx(function () { return [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.events, function (event) {
                            return (_openBlock(), _createBlock(_unref(SwiperSlide), {
                                class: "event-swiper__slide",
                                key: event.id
                            }, {
                                default: _withCtx(function () { return [
                                    _createElementVNode("div", {
                                        class: "event-swiper__card",
                                        style: _normalizeStyle({
                                            background: "linear-gradient(89.79deg, rgba(0, 0, 0, 0.7) 5.09%, rgba(0, 0, 0, 0) 99.89%), url(".concat(event.image, ")"),
                                            backgroundPosition: 'center',
                                            backgroundSize: 'cover',
                                            backgroundRepeat: 'no-repeat'
                                        })
                                    }, [
                                        _createElementVNode("p", _hoisted_1, _toDisplayString(event.name), 1),
                                        _createElementVNode("div", _hoisted_2, [
                                            _createVNode(_component_el_icon, { size: 12 }, {
                                                default: _withCtx(function () { return [
                                                    _createVNode(ClockIcon, { color: '#fff' })
                                                ]; }),
                                                _: 1
                                            }),
                                            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(formatEventDate)(event === null || event === void 0 ? void 0 : event.date, event === null || event === void 0 ? void 0 : event.startTime, event === null || event === void 0 ? void 0 : event.endTime).date), 1),
                                            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "dot-separator" }, "·", -1)),
                                            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(formatEventDate)(event === null || event === void 0 ? void 0 : event.date, event === null || event === void 0 ? void 0 : event.startTime, event === null || event === void 0 ? void 0 : event.endTime).time), 1)
                                        ])
                                    ], 4)
                                ]; }),
                                _: 2
                            }, 1024));
                        }), 128))
                    ]; }),
                    _: 1
                }, 8, ["pagination", "modules"]),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "event-swiper__pagination" }, null, -1))
            ], 64));
        };
    }
});
